import ContentLoader from 'react-content-loader';

export const PageCatchesGridLoader = () => {
  return (
    <div className="size-full">
      <ContentLoader
        uniqueKey={`postimage-grid-loader`}
        id={`postimage-grid-loader`}
        className="flex h-[350px] w-full items-center justify-center"
      >
        <rect x="0" y="0" width="100%" height="100%" />
      </ContentLoader>
    </div>
  );
};
